// extracted by mini-css-extract-plugin
export default {"title":"OnboardingQRModal__title--pXvzY","description":"OnboardingQRModal__description--1exdI","content":"OnboardingQRModal__content--fP2_d","qr":"OnboardingQRModal__qr--12Mme"};